import React from 'react'
import "./AboutTabContent.css"

const AboutTabwhyus = () => {
    return (
        <div className="about-tab-contents">
            <h2 className="about-tab-contents-h2">
                Why us
            </h2>
            <p className="about-tab-contents-p">
                The pillar of any company that deals with logistics is the ability to deliver on time with minimal risk of loss. At 940 Air Cargo, we leverage our extensive contacts and local knowledge to ensure your business runs smoothly.
            </p>
            <ul>
                <li>Expertise in IVF and temperature-sensitive logistics (-180°C).</li>
                <li>Extensive regional and international network.</li>
                <li>Local language advantages for seamless operations.</li>
                <li>Meticulous planning and execution.</li>
            </ul>
        </div>
    )
}

export default AboutTabwhyus
